<template>
  <div class="content wonderfulReview" id="content">
    <div class="posi">
      当前位置： 首页 &nbsp;>>&nbsp; 学术与交流 &nbsp;>>&nbsp;
      <span>精彩回顾</span>
    </div>
    <div class="review" v-for="(item,index) in reviewList" :key="index" @click="currentReviewDetail(item.id)">
      <div class="imgDiv">
        <img v-if="!item.imgUrl" :src="getBase64ImageUrl(item)" alt="" />
        <img v-else :src="item.imgUrl" alt="" />
      </div>
      <div class="textDiv">
        <p>
          <span style="float: left; font-size: 18px">{{ item.title }}</span>
          <span style="float: right; font-size: 12px; color: #bbbbbb"
            >{{ item.createTime }}</span
          >
        </p>
        <p class="reviewContent">
          {{ item.author }}
        </p>
      </div>
    </div>
    <div class="page">
      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        layout="prev, pager, next, slot"
        :total="totalSize"
      >
        <el-input type="text" v-model="pageNum"></el-input>
        <el-button class="tz" @click="pageTz">跳转</el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      pageNum: null,
      totalSize: 0,
      reviewList: []
    };
  },
  mounted() {
    this.initWonderfulReviews();
  },
  methods: {
    // 初始化
    initWonderfulReviews() {
       this.$http({
        url: "/api/infomation/list",
        method: "get",
        params: this.$http.adornParams({
          type: "jchg",
          pageNo: this.pageIndex,
          length: this.pageSize,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((res) => {
              res.createTime = this.$moment(res.createTime).format("YYYY-MM-DD")
              res.imgUrl = "";
            });
            this.reviewList = data.recordList;
            this.totalSize = data.totalRow;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => console.log(err));
    },

    // 图片回显
    async getBase64ImageUrl(file) {
      if (file.filePath) {
        let promise = await this.$http.get(
          `${this.$http.adornUrl("/file/showImgBase64?imgPath=")}${
            file.filePath
          }`
        );
        file.imgUrl = promise.data;
      }
    },

    // 详情
    currentReviewDetail(id) {
      this.$router.push({
        path: "/reviewDetails",
        query: {
          id: id
        }
      })
    },

    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.initWonderfulReviews();
    },

    // 尾页
    pageTz() {
      this.pageIndex = this.pageNum;
      this.initWonderfulReviews();
    },
  },
};
</script>
<style lang="scss">
.wonderfulReview {
  .review {
    height: 118px;
    border-bottom: 1px solid #e5e5e5;
    padding-top: 30px;
    cursor: pointer;
  }

  .imgDiv {
    width: 140px;
    height: 88px;
    float: left;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .textDiv {
    width: 798px;
    height: 82px;
    float: right;
    padding-top: 6px;
  }

  .textDiv p:first-child {
    height: 18px;
    line-height: 18px;
  }

  .reviewContent {
    width: 541px;
    height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    line-height: 24px;
    color: #8a8a8a;
    text-indent: 24px;
    margin-top: 15px;
  }

  .page {
    margin-top: 70px;
    text-align: center;
  }

  .btn-prev,
  .btn-next {
    width: 52px;
    height: 32px !important;
    color: #eeeeee;
  }

  .btn-next {
    margin: 0 10px 0 5px !important;
  }

  .el-icon-arrow-left:before {
    content: "上一页";
  }

  .el-icon-arrow-right:before {
    content: "下一页";
  }

  .el-pager {
    height: 32px;
  }

  .el-pager li {
    height: 100%;
    width: 32px !important;
    line-height: 32px !important;
  }

  .el-pager li:hover {
    background-color: #2878ff !important;
    color: #ffffff !important;
  }

  .active {
    background-color: #2878ff !important;
  }

  .btn-quicknext {
    height: 32px;
    line-height: 32px !important;
  }

  .el-pagination {
  }

  .el-pagination .el-button {
    width: 54px;
    height: 32px;
    background-color: #eeeeee;
    color: #525252;
    margin-left: 8px;
  }

  .el-pagination button:hover {
    color: #525252 !important;
  }

  .el-pagination .el-button span {
    line-height: 32px;
  }

  .el-pagination .el-input {
    width: 32px;
    height: 32px;
  }

  .el-pagination .el-input .el-input__inner {
    border-radius: 0;
    width: 32px;
    height: 32px;
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
</style>